module.exports = __webpack_public_path__ + "img/73f52db6024ebd61ef48cf0be476f02.044d44d0.png";